import { GetServerSideProps } from 'next';
import { useState } from 'react';

import FormPage from '@src/components/FormPage';
import ReasonForVisit from '@src/components/ReasonForVisit';
import { getCommonServerSideProps } from '@src/utils/get-common-server-side-props';

const ReasonForVisitPage = () => {
	const [loading, setLoading] = useState(false);
	const formId = 'reason-for-visit';

	return (
		<FormPage formId={formId} loading={loading} title="Reason for Visit" setLoading={setLoading}>
			<ReasonForVisit formId={formId} setLoading={setLoading} />
		</FormPage>
	);
};

export const getServerSideProps: GetServerSideProps = async (context) => {
	return getCommonServerSideProps(context, { pageName: 'reason-for-visit' });
};

export default ReasonForVisitPage;
